function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M31.824 15.454C31.54 15.055 24.666 5.687 16 5.687S.461 15.056.176 15.454a.935.935 0 000 1.092c.285.399 7.158 9.767 15.824 9.767s15.538-9.368 15.824-9.767a.935.935 0 000-1.092zM16 22.562A6.57 6.57 0 019.437 16 6.57 6.57 0 0116 9.437 6.57 6.57 0 0122.563 16 6.57 6.57 0 0116 22.563z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 13.188A2.816 2.816 0 0013.187 16 2.816 2.816 0 0016 18.813 2.816 2.816 0 0018.813 16 2.816 2.816 0 0016 13.187z",
  fill: "currentColor"
});

function SvgIconView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+CiAgPHBhdGggZD0iTTMxLjgyNCAxNS40NTRDMzEuNTQgMTUuMDU1IDI0LjY2NiA1LjY4NyAxNiA1LjY4N1MuNDYxIDE1LjA1Ni4xNzYgMTUuNDU0YS45MzUuOTM1IDAgMDAwIDEuMDkyYy4yODUuMzk5IDcuMTU4IDkuNzY3IDE1LjgyNCA5Ljc2N3MxNS41MzgtOS4zNjggMTUuODI0LTkuNzY3YS45MzUuOTM1IDAgMDAwLTEuMDkyek0xNiAyMi41NjJBNi41NyA2LjU3IDAgMDE5LjQzNyAxNiA2LjU3IDYuNTcgMCAwMTE2IDkuNDM3IDYuNTcgNi41NyAwIDAxMjIuNTYzIDE2IDYuNTcgNi41NyAwIDAxMTYgMjIuNTYzeiIgZmlsbD0iY3VycmVudENvbG9yIi8+CiAgPHBhdGggZD0iTTE2IDEzLjE4OEEyLjgxNiAyLjgxNiAwIDAwMTMuMTg3IDE2IDIuODE2IDIuODE2IDAgMDAxNiAxOC44MTMgMi44MTYgMi44MTYgMCAwMDE4LjgxMyAxNiAyLjgxNiAyLjgxNiAwIDAwMTYgMTMuMTg3eiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgIconView as ReactComponent };